<template>
  <VRow justify="center">
    <VCol
      class="px-2 pb-2 d-flex align-center pt-0"
      cols="12"
    >
      <div>
        <span class="body-1">
          {{ $t('authForm.phoneNumber') }}
        </span>
      </div>
      <div class="ml-2">
        <span class="body-bold">
          {{ phone }}
        </span>
      </div>
      <div class="ml-2">
        <VBtn
          small
          class="box-shadow-elevation-4"
          @click="$emit('toStartStep')"
        >
          <span class="small-button">
            {{ $t('general.edit') }}
          </span>
        </VBtn>
      </div>
    </VCol>
    <VerificationPhone
      ref="verificationPhone"
      :receivedRemainingTime="receivedRemainingTime"
      :otpExpiredAt="otpExpiredAt"
      :phone="phone"
      :receivedErrorCode="receivedErrorCode"
      :isPasswordResetStep="false"
      @resendCode="$emit('sendVerificationCodeForExistingUser', true)"
      @onSubmit="onSubmit"
    />
  </VRow>
</template>
<script lang="ts">
export default {
  name: 'VerificationRegisteredUserStep',
};
</script>

<script setup lang="ts">
import { onDeactivated, ref } from 'vue';
import VerificationPhone from '@slg/web-customer-shared/src/components/authForm/verificationPhone/VerificationPhone.vue';

defineProps({
  receivedRemainingTime: {
    type: Number,
    default: 0,
  },
  otpExpiredAt: {
    type: Number,
    default: 0,
  },
  phone: {
    type: String,
    default: '',
  },
  receivedErrorCode: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['trackGtmEventForUserCreatedByOperator', 'recoverPassword']);

const verificationPhone = ref<any>(null);

onDeactivated(() => {
  verificationPhone.value.clearOtpAndErrorCode();
});

function onSubmit(verificationCode: any, attempts: any) {
  emit('trackGtmEventForUserCreatedByOperator');
  emit('recoverPassword', verificationCode, attempts, true);
}
</script>
<style lang="scss" scoped>
.verification-code {
    height: 50px;
    .code-input {
      height: 100%;
      width: 15%;
      border-bottom: 1px solid;
      margin-right: 8px;
      color: var(--v-textTertiary-base);
      text-align: center;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-radius: 0;
      -webkit-appearance: initial;

      &.expired-error {
        border-bottom-color: var(--v-error-base);
      }
    }
    .code-input:last-child {
      margin-right: 0;
    }
}
</style>
